module.exports = __webpack_public_path__ + "static/media/quiz1.d574f581.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Projects/PP/assets/quiz1.png
// module id = 211
// module chunks = 0